import React from "react";

import LendmarqLogo from "../../../assets/LendmarqLogo";

/**
 * Lendmarq replacement for tpo-portal-frontend's BrandLogo.
 *
 * tpo renders the active brand's uploaded image, or the Marq wordmark SVG for
 * its default brand. There is one partner here, so this is always the Lendmarq
 * wordmark vector — the same asset the dashboard header uses. The prop
 * signature is unchanged so the vendored public-form shells keep working.
 *
 * `color` is accepted but ignored. The public forms' chrome is white (see
 * brandReducer), so the wordmark always renders in brand blue; honoring the
 * caller's `headerFg` would paint it near-black on that white surface. Restore
 * `fill={color || undefined}` if the rail ever goes back to a dark background.
 */
const BrandLogo = ({ height = 40, maxWidth = 240 }) => (
  <LendmarqLogo height={height} style={{ maxWidth, width: "auto" }} />
);

export default BrandLogo;
